import { AxiosInstance } from 'axios';
import {
  AccessibilityServiceModel,
  initAccessibilityService,
} from './Accessibility/AccessibilityService';
import { LanguageServiceModel, initLanguageService } from './Language/LanguageService';
import { QuickMenuServiceModel, initQuickMenuService } from './QuickMenu/QuickMenuService';
import { SecurityServiceModel, initSecurityService } from './Security/SecurityService';

export interface SettingApplicationSettingsServiceModel {
  Language: LanguageServiceModel;
  Security: SecurityServiceModel;
  Accessibility: AccessibilityServiceModel;
  QuickMenu: QuickMenuServiceModel;
}

export const initSettingApplicationSettingsService = (
  axios: AxiosInstance
): SettingApplicationSettingsServiceModel => ({
  Language: initLanguageService(axios),
  Security: initSecurityService(axios),
  Accessibility: initAccessibilityService(axios),
  QuickMenu: initQuickMenuService(axios),
});
